var React = require('react');

function ArrowDownInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M10.5234 0H13.5234V114.281L21.9256 105.879L24.0469 108L14.1421 117.899L12.0208 120.021L9.90475 117.899L0 108L2.12131 105.879L10.5234 114.281V0Z","fill":"#1F1F1F"}));
}

ArrowDownInline.defaultProps = {"width":"25","height":"121","viewBox":"0 0 25 121","fill":"none"};

module.exports = ArrowDownInline;

ArrowDownInline.default = ArrowDownInline;
